// extracted by mini-css-extract-plugin
export default {"barcodeImage":"PlatePunching_barcodeImage__5-TGB"};